// Clic audio optionnel du métronome. Le métronome visuel reste la référence : en mode
// micro, le clic est capté par le micro de l'appareil (casque conseillé). Le clic est
// un bruit bref, sans hauteur nette, pour ne pas être pris pour une note.

export class Metronome {
  enabled = false;
  private ctx: AudioContext | null = null;
  private accent: AudioBuffer | null = null;
  private normal: AudioBuffer | null = null;

  private ensure(): AudioContext | null {
    if (typeof AudioContext === 'undefined') return null;
    if (!this.ctx) this.ctx = new AudioContext();
    if (!this.accent) this.accent = this.makeClick(0.9);
    if (!this.normal) this.normal = this.makeClick(0.6);
    return this.ctx;
  }

  private makeClick(gain: number): AudioBuffer {
    const ctx = this.ctx as AudioContext;
    const sr = ctx.sampleRate;
    const n = Math.floor(sr * 0.025);
    const buffer = ctx.createBuffer(1, n, sr);
    const data = buffer.getChannelData(0);
    let s = 12345;
    for (let i = 0; i < n; i++) {
      s = (s * 1664525 + 1013904223) % 4294967296;
      const noise = (s / 4294967296) * 2 - 1;
      const env = Math.exp(-i / (sr * 0.004));
      data[i] = noise * env * gain;
    }
    return buffer;
  }

  click(accent: boolean): void {
    if (!this.enabled) return;
    const ctx = this.ensure();
    if (!ctx || !this.accent || !this.normal) return;
    if (ctx.state === 'suspended') void ctx.resume();
    const src = ctx.createBufferSource();
    src.buffer = accent ? this.accent : this.normal;
    const filter = ctx.createBiquadFilter();
    filter.type = 'bandpass';
    filter.frequency.value = accent ? 4200 : 3200;
    filter.Q.value = 1.2;
    const g = ctx.createGain();
    g.gain.value = 0.8;
    src.connect(filter);
    filter.connect(g);
    g.connect(ctx.destination);
    src.start();
  }

  dispose(): void {
    if (this.ctx) void this.ctx.close();
    this.ctx = null;
    this.accent = null;
    this.normal = null;
  }
}
